import { AFFILIATE_FETCHING, AFFILIATE_FAILED, AFFILIATE_SUCCESS } from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case AFFILIATE_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case AFFILIATE_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case AFFILIATE_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
